function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Minimise = function Minimise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M9.927 13.081h.032l.052.004zq.078 0 .155.012l.035.007a1 1 0 0 1 .095.022l.011.004q.045.014.088.031l.033.015q.038.016.074.037l.028.017a1 1 0 0 1 .076.051l.017.014.003.001.01.008q.089.07.158.16l-.076-.086q.06.06.106.125l.031.046.012.02.014.023a1 1 0 0 1 .04.078l.013.032.028.073.013.044a.8.8 0 0 1 .032.177l.004.089v6.473a1 1 0 1 1-2 0l-.001-4.059-6.22 6.22a.997.997 0 0 1-1.413 0 1 1 0 0 1 0-1.414l6.22-6.22h-4.06a1 1 0 0 1 0-2zM22.749 1.293a1 1 0 0 1 0 1.414l-6.22 6.22h4.059a1 1 0 1 1 0 2h-6.472q-.06 0-.12-.007l-.008-.001-.018-.003a1 1 0 0 1-.22-.058l-.038-.016-.036-.017-.03-.015a1 1 0 0 1-.385-.363l-.016-.028a1 1 0 0 1-.04-.079l-.012-.027-.019-.049-.011-.033a1 1 0 0 1-.032-.128l-.005-.028a1 1 0 0 1-.01-.131v-6.49a1 1 0 1 1 2 0v4.058l6.219-6.22a1 1 0 0 1 1.414 0"
  }));
};
export default Minimise;